<template>
    <div class="e-container">
        <el-row>
            <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd()" plain>新增</el-button>
        </el-row>
        <el-table
            ref="tableData"
            v-loading="loading"
            :data="tableData.list"
            size="small"
            style="width: 100%">
            <el-table-column
                type="selection"
                width="55">
            </el-table-column>
            <el-table-column
                prop="name"
                label="名称">
            </el-table-column>
            <el-table-column
                prop="code"
                label="编码">
            </el-table-column>
            <el-table-column
                prop="description"
                label="描述">
            </el-table-column>
            <el-table-column
                label="操作">
                <template slot-scope="scope">
                    <el-button @click="handleDetail(scope.row)" type="text" size="small">查看</el-button>
                    <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="handleItems(scope.row)" type="text" size="small">字典项</el-button>
                    <el-button @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="e-table-bottom-bar">
            <el-pagination
                background
                layout="total, sizes, prev, pager, next"
                @size-change="loadData"
                @current-change="loadData"
                :page-size.sync="tableData.page.pageSize"
                :current-page.sync="tableData.page.pageIndex"
                :total="tableData.page.count">
            </el-pagination>
        </div>

        <!-- 编辑框 -->
        <el-dialog :title="'字典管理-' + (ruleFormEdit ? '编辑' : '查看')" width="800px" :visible.sync="dialogEditVisible">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
                     size="small" style="padding-right: 50px" v-loading="ruleFormEditLoading">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="名称" prop="name">
                            <el-input v-model="ruleForm.name" :readonly="!ruleFormEdit"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="编码" prop="code">
                            <el-input v-model="ruleForm.code" :readonly="!ruleFormEdit"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="描述" prop="description">
                    <el-input type="textarea" v-model="ruleForm.description" :readonly="!ruleFormEdit"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button v-if="ruleFormEdit" type="primary" @click="handleSubmitForm()">
                        {{ ruleForm.id ? '修改' : '创建' }}
                    </el-button>
                    <el-button @click="handleCloseForm()">关闭</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <!-- 字典项表格 -->
        <el-dialog title="字典项" width="1000px" :visible.sync="dialogItemTableVisible">
            <el-row>
                <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleItemAdd()" plain>新增</el-button>
                <el-button type="danger" icon="el-icon-delete" size="mini" disabled plain>删除</el-button>
            </el-row>
            <el-table
                ref="tableData"
                v-loading="itemLoading"
                :data="itemTableData.list"
                size="small"
                style="width: 100%">
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column
                    label="名称">
                    <template slot>
                        {{ itemTableParams.dictName }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="编码">
                    <template slot>
                        {{ itemTableParams.dictCode }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="label"
                    label="标签">
                </el-table-column>
                <el-table-column
                    prop="value"
                    label="值">
                </el-table-column>
                <el-table-column
                    prop="description"
                    label="描述">
                </el-table-column>
                <el-table-column
                    label="操作">
                    <template slot-scope="scope">
                        <el-button @click="handleItemDetail(scope.row)" type="text" size="small">查看</el-button>
                        <el-button @click="handleItemEdit(scope.row)" type="text" size="small">编辑</el-button>
                        <el-button @click="handleItemDelete(scope.row)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页组件 -->
            <div class="e-table-bottom-bar">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next"
                    @size-change="loadItemData(false)"
                    @current-change="loadItemData(false)"
                    :page-size.sync="itemTableData.page.pageSize"
                    :current-page.sync="itemTableData.page.pageIndex"
                    :total="itemTableData.page.count">
                </el-pagination>
            </div>
        </el-dialog>

        <!-- 编辑框 -->
        <el-dialog :title="'字典项-' + (itemRuleFormEdit ? '编辑' : '查看')" width="800px"
                   :visible.sync="dialogItemEditVisible">
            <el-form :model="itemRuleForm" :rules="itemRules" ref="itemRuleForm" label-width="100px"
                     class="demo-ruleForm" size="small" style="padding-right: 50px" v-loading="itemRuleFormEditLoading">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="名称">
                            <el-input v-model="itemTableParams.dictName" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="编码">
                            <el-input v-model="itemTableParams.dictCode" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="标签" prop="label">
                            <el-input v-model="itemRuleForm.label" :readonly="!itemRuleFormEdit"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="值" prop="value">
                            <el-input v-model="itemRuleForm.value" :readonly="!itemRuleFormEdit"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="描述" prop="description">
                    <el-input type="textarea" v-model="itemRuleForm.eDescription"
                              :readonly="!itemRuleFormEdit"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button v-if="itemRuleFormEdit" type="primary" @click="handleItemSubmitForm()">
                        {{ itemRuleForm.id ? '修改' : '创建' }}
                    </el-button>
                    <el-button @click="handleItemCloseForm('ruleForm')">关闭</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
import {
    page,
    getObj,
    saveObj,
    updateObj,
    deleteObj,
    itemPage,
    getItem,
    saveItem,
    updateItem,
    deleteItem
} from "@/apis/system/dict"

export default {
    name: 'SysDict',

    data() {
        return {
            loading: false,
            itemLoading: false,
            ruleFormEditLoading: false,
            itemRuleFormEditLoading: false,

            tableData: {
                list: [],
                page: {
                    pageSize: 10,
                    pageIndex: 1
                }
            },
            itemTableData: {
                list: [],
                page: {
                    pageSize: 10,
                    pageIndex: 1
                }
            },

            itemTableParams: {},

            dialogEditVisible: false,
            dialogItemTableVisible: false,
            dialogItemEditVisible: false,

            ruleFormEdit: false,
            itemRuleFormEdit: false,
            ruleForm: {},
            itemRuleForm: {},
            rules: {
                name: [
                    {required: true, message: '请输入名称', trigger: 'blur'},
                ],
                code: [
                    {required: true, message: '请输入编码', trigger: 'blur'},
                ]
            },
            itemRules: {
                label: [
                    {required: true, message: '请输入标签', trigger: 'blur'},
                ],
                value: [
                    {required: true, message: '请输入值', trigger: 'blur'},
                ]
            }
        }
    },

    components: {},

    computed: {},

    mounted() {
        let pageSize = this.UserConfigStore.getItem("pageSize");
        if (pageSize) {
            this.tableData.page.pageSize = pageSize;
        }
        this.loadData();
    },

    methods: {

        // 数据获取

        loadData() {
            this.UserConfigStore.setItem("pageSize", this.tableData.page.pageSize);
            let params = {
                pageSize: this.tableData.page.pageSize,
                pageIndex: this.tableData.page.pageIndex
            }
            this.loading = true;
            page(params).then(res => {
                this.loading = false;
                this.tableData = res.data;
            }).catch((ex) => {
                this.loading = false;
                this.$message.error(ex.message);
            });
        },

        loadItemData(init) {
            let params = {
                pageSize: this.itemTableData.page.pageSize,
                pageIndex: init ? 1 : this.itemTableData.page.pageIndex,
                dictId: this.itemTableParams.dictId
            }
            this.itemLoading = true;
            itemPage(params).then(res => {
                this.itemLoading = false;
                this.itemTableData = res.data;
            }).catch((ex) => {
                this.itemLoading = false;
                this.$message.error(ex.message);
            });
        },

        // 表格操作

        handleAdd() {
            this.ruleForm = {};
            this.ruleFormEdit = true;
            this.dialogEditVisible = true;
        },

        handleEdit(row) {
            this.ruleFormEdit = true;
            this.dialogEditVisible = true;
            this.ruleFormEditLoading = true;
            getObj(row.id).then((res) => {
                this.ruleForm = res.data;
            }).catch((ex) => {
                this.$message.error(ex.message);
            }).finally(() => {
                this.ruleFormEditLoading = false;
            });
        },

        handleDetail(row) {
            this.ruleFormEdit = false;
            this.dialogEditVisible = true;
            this.ruleFormEditLoading = true;
            getObj(row.id).then((res) => {
                this.ruleForm = res.data;
            }).catch((ex) => {
                this.$message.error(ex.message);
            }).finally(() => {
                this.ruleFormEditLoading = false;
            });
        },

        handleDelete(row) {
            this.$confirm("确定要删除该数据吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                deleteObj(row.id).then(() => {
                    this.$message.success("删除成功");
                    this.loadData();
                }).catch((ex) => {
                    this.$message.error(ex.message);
                });
            });
        },

        handleItems(row) {
            this.itemTableParams = {
                dictId: row.id,
                dictName: row.name,
                dictCode: row.code
            }
            this.dialogItemTableVisible = true;
            this.loadItemData(true);
        },

        // 子项操作

        handleItemAdd() {
            this.itemRuleForm = {
                dictId: this.itemTableParams.dictId
            };
            this.itemRuleFormEdit = true;
            this.dialogItemEditVisible = true;
        },

        handleItemEdit(row) {
            this.itemRuleFormEdit = true;
            this.dialogItemEditVisible = true;
            this.itemRuleFormEditLoading = true;
            getItem(row.id).then((res) => {
                this.itemRuleForm = res.data;
            }).catch((ex) => {
                this.$message.error(ex.message);
            }).finally(() => {
                this.itemRuleFormEditLoading = false;
            });
        },

        handleItemDetail(row) {
            this.itemRuleFormEdit = false;
            this.dialogItemEditVisible = true;
            this.itemRuleFormEditLoading = true;
            getItem(row.id).then((res) => {
                this.itemRuleForm = res.data;
            }).catch((ex) => {
                this.$message.error(ex.message);
            }).finally(() => {
                this.itemRuleFormEditLoading = false;
            });
        },

        handleItemDelete(row) {
            this.$confirm("确定要删除该数据吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                deleteItem(row.id).then(() => {
                    this.$message.success("删除成功");
                    this.loadItemData();
                }).catch((ex) => {
                    this.$message.error(ex.message);
                });
            });
        },

        // 表单操作

        handleSubmitForm() {
            this.$refs.ruleForm.validate((valid) => {
                if (!valid) {
                    return;
                }
                this.ruleFormEditLoading = true;
                (this.ruleForm.id ? updateObj(this.ruleForm) : saveObj(this.ruleForm)).then(() => {
                    this.$message.success(`${this.ruleForm.id ? '修改' : '创建'}成功`);
                    this.dialogEditVisible = false;
                    this.loadData();
                }).catch((ex) => {
                    this.$message.error(ex.message);
                }).finally(() => {
                    this.ruleFormEditLoading = false;
                });
            });
        },

        handleCloseForm() {
            this.dialogEditVisible = false;
        },

        handleItemSubmitForm() {
            this.$refs.itemRuleForm.validate((valid) => {
                if (!valid) {
                    return;
                }
                this.itemRuleFormEditLoading = true;
                (this.itemRuleForm.id ? updateItem(this.itemRuleForm) : saveItem(this.itemRuleForm)).then(() => {
                    this.$message.success(`${this.itemRuleForm.id ? '修改' : '创建'}成功`);
                    this.dialogItemEditVisible = false;
                    this.loadItemData();
                }).catch((ex) => {
                    this.$message.error(ex.message);
                }).finally(() => {
                    this.itemRuleFormEditLoading = false;
                });
            });
        },

        handleItemCloseForm() {
            this.dialogItemEditVisible = false;
        },

    }
}

</script>

<style scoped lang='scss'>
@import '~@/assets/styles/base-page.scss';
</style>
